import styled from 'styled-components';
import baseStyledContentWrapper from 'common/ContentLoader/StyledContentWrapper';

const StyledContentWrapper = styled(baseStyledContentWrapper)`
    width: 100%;
    margin: auto;
`;

export default StyledContentWrapper;
